import { ACTION } from '@/store/ACTION';

class ToolTipController {
  protected totalBet: number = 0;

  protected allowed(): boolean {
    return (
      this.store.promo.hasPromoApp() &&
      (this.store.promo.isAchievement ||
        this.store.promo.isAchievementBG ||
        this.store.promo.isAchievementFS ||
        (this.store.promo.isValidTournamentGame() && this.store.promo.isProgressTournament())) &&
      !this.store.promo.isBetProperly(this.totalBet) &&
      !this.store.promo.isToolTipOnce &&
      !this.store.gameData.freeSpinsGame.isPlaying() &&
      !this.store.gameData.bonusGame.isPlaying() &&
      this.store.promo.isStartPromo
    );
  }

  execution(): void {
    if (!this.allowed()) return;

    promoApp.eventEmitter.emit(ACTION.SHOW_TOOLTIP);
    this.store.promo.statusToolTip = true;
  }

  saveTotalBet(): void {
    const { mode } = this.store.getServerMode('buy');
    const price = mode ? mode.price : 1;
    this.totalBet = this.store.gameData.bet * price;
  }

  get store() {
    return game.store;
  }
}

export { ToolTipController };
